import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faPlay, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FormControl, Button } from '@material-ui/core';
import FormData from 'form-data'
import { useDispatch } from "react-redux"

import {
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import { getParticipanteLogImportacao, postImportParticipantes } from '../../../services/api-auto'
import Paginacao from '../../../components/Paginacao';
import exemploDesempenho from '../../../assets/docs/LayoutImportacaoParticipantes.xlsx'
import LogImportacao from './components/LogImportacao';
import styles from './styles.module.scss'

const Resultados = () => {

    const ref = useRef(null)
    const [dados, setDados] = useState(null)

    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);


    const [logList, setLogList] = useState([]);

    const [loading, setLoading] = useState(false);


    const dispatch = useDispatch();
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const getLogList = async () => {
        const info = await getParticipanteLogImportacao(page)
        setLogList(info.data.data)
        setMaxPage(info.data.maxPage)
    }

    const postImportacao = async () => {
        setLoading(true)
        const formdata = new FormData();
        formdata.append('dados', dados)

        try {
            const info = await postImportParticipantes(formdata);
            if (Boolean(info.fail)) {

            } else {
                showMsgS("Resultados carregados com sucesso")
                setLoading(false);
                getLogList();
            }
        } catch (e) {
            showMsgE("Ocorreu um erro e não foi possível carregar os dados")
        } finally {
            setLoading(false)
        }
    }

    const onFileChange = (event) => {
        let file;
        if (event.target.files && event.target.files[0]) {
            file = event.target.files[0];
            if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setDados(file);
            } else {
                showMsgE('Favor escolher arquivos .xlsx')
            }
        }
    };

    const callFileInput = () => {
        ref.current.click()
    }

    useEffect(() => {
        getLogList();
    }, [page])

    return (
        <div className={`${styles.wrapper}`}>
            <div className={styles.title}>
                Importação de PDVs
            </div>
            <div className={`${styles.actions}`}>
                <div className={`${styles.card}`}>
                    <div className={`${styles.cardTitle}`}>
                        Orientações
                    </div>
                    <div className={`${styles.modelo}`}>
                        <FormControl>
                            <Button href={exemploDesempenho} download className={'customButton bigButton bold'}>
                                <FontAwesomeIcon icon={faDownload} className={styles.icon} />
                                Baixar modelo de planilha
                            </Button>
                        </FormControl>
                    </div>
                    <div className={`${styles.orientacoes}`}>
                        <ul>
                            <li>
                                Clique em "Baixar modelo de planilha" para fazer o download da planilha de importação;
                            </li>
                            <li>
                                A planilha deve estar no formato .xlsx;
                            </li>
                            <li>
                                O arquivo não deve conter células mescladas;
                            </li>
                            <li>
                                A primeira linha deve conter o cabeçalho das colunas;
                            </li>
                            <li>
                                Deve haver somente uma aba no arquivo;
                            </li>
                            <li>
                                Após a importação, veja o resultado de cada registro clicando nos números processados;
                            </li>
                            <li className={`${styles.highlight}`} >
                                No caso de erro no upload, será gerada uma planilha com o descritivo do erro de leitura na última coluna. Favor consultar, ajustar e carregar novamente.
                            </li>
                        </ul>

                    </div>
                    <div className={`${styles.importacoes}`}>
                        <div className={`${styles.cardTitle}`}>
                            Upload de arquivo
                        </div>
                        <FormControl>
                            <input type='file' onChange={onFileChange} style={{ display: 'none' }} ref={ref} />
                            <Button className={`customButton bigButton bold ${dados !== null ? styles.blue : null}`} onClick={callFileInput}>
                                Adicionar planilha preenchida
                            </Button>
                        </FormControl>
                        <FormControl>
                            <Button className={`${styles.processar} bold`} onClick={postImportacao} disabled={loading}>
                                {
                                    !loading ?
                                        (
                                            <>
                                                <FontAwesomeIcon icon={faPlay} className={styles.icon} />
                                                PROCESSAR PLANILHA
                                            </>
                                        ) :
                                        (
                                            <FontAwesomeIcon icon={faSpinner} className={styles.icon} spin={true} />
                                        )
                                }
                            </Button>
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={`${styles.actions}`}>
                <div className={`${styles.logs}`}>
                    <div className={`${styles.cardTitle}`}>
                        Log de importação
                    </div>
                    <div>
                        {
                            logList.map(log => (<LogImportacao log={log} key={log.id} />))
                        }
                    </div>
                    <div className={` ${styles.paginacaoWrapper}`}>
                        {maxPage > 1 && (
                            <Paginacao maxPage={maxPage} page={page} setPage={setPage} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Resultados